//packages
import React, { Component } from 'react'

//form elements
import PopoverOfForm from '../../PopoverOfForm'

class RegionTooltip extends Component {
    render () {
        return (
            <PopoverOfForm>
                <p>Select one or more regional areas to limit the scope of your search to those regions. </p>
                <p>Select the region you want to search from the drop down list. You can select from the list of
                            circuits or actual regions, such as "New Jersey." </p>
                <p>You may also select a state or Circuit from an interactive map. Click on the desired region and the
                            selection list will be updated automatically. You can click on multiple regions and the selection
                            list will add them. Click on any region a second time to unselect it.</p>
            </PopoverOfForm>
        )
    }
}

export default RegionTooltip




// WEBPACK FOOTER //
// ./src/components/search/FormElements/tooltips/RegionTooltip/RegionTooltip.js